// Scenario engine — PSD §7.2 (F7.2). Engine layer (framework-free).
import { runValuation } from './runValuation';
/**
 * Run a single scenario with overrides applied to the base inputs.
 */
export function runScenario(base, scenario) {
    try {
        const variant = {
            ...base,
            assumptions: {
                ...base.assumptions,
                volatility: scenario.volatilityOverride ?? base.assumptions.volatility,
                timeToLiquidity: scenario.timeToLiquidityOverride ?? base.assumptions.timeToLiquidity,
            },
            discounts: {
                ...base.discounts,
                dlomPercentage: scenario.dlomOverride ?? base.discounts.dlomPercentage,
            },
            equityValue: {
                ...base.equityValue,
                directEquityValue: scenario.equityValueOverride ?? base.equityValue.directEquityValue,
            },
        };
        return { scenario, result: runValuation(variant), error: null };
    }
    catch (e) {
        return { scenario, result: null, error: e instanceof Error ? e.message : /* v8 ignore next */ String(e) };
    }
}
/** Default scenario presets derived from base inputs. */
export function defaultPresets(base) {
    return [
        {
            id: 'base',
            name: 'Base',
            preset: 'base',
            equityValueOverride: null,
            volatilityOverride: null,
            timeToLiquidityOverride: null,
            dlomOverride: null,
        },
        {
            id: 'conservative',
            name: 'Conservative',
            preset: 'conservative',
            equityValueOverride: base.equityValue.directEquityValue
                ? base.equityValue.directEquityValue * 0.75
                : null,
            volatilityOverride: Math.min(0.9, base.assumptions.volatility * 1.2),
            timeToLiquidityOverride: base.assumptions.timeToLiquidity * 1.3,
            dlomOverride: Math.min(0.6, base.discounts.dlomPercentage * 1.3),
        },
        {
            id: 'aggressive',
            name: 'Aggressive',
            preset: 'aggressive',
            equityValueOverride: base.equityValue.directEquityValue
                ? base.equityValue.directEquityValue * 1.25
                : null,
            volatilityOverride: Math.max(0.1, base.assumptions.volatility * 0.85),
            timeToLiquidityOverride: base.assumptions.timeToLiquidity * 0.8,
            dlomOverride: Math.max(0, base.discounts.dlomPercentage * 0.7),
        },
    ];
}
//# sourceMappingURL=scenarios.js.map